import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "redux";

import { PAYMENT_RESULT_TOAST_ID } from "@config/consts";

import { PAYMENT_STATUS } from "@typings/payments";

import { PaymentProcessed as PaymentProcessedOrganism } from "@ui/Organisms";

import { showToast, TypeOptions } from "@containers/Toastify";

import { useTranslate } from "@hooks/useTranslate";

import {
  fetchPaymentStatus,
  setReferenceNumber,
  setOriginRoute,
  setTargetRoute,
} from "@soft/redux/payment/payment.actions";
import {
  getPaymentStatus,
  getOriginRoute,
  getTargetRoute,
  getPublicMessage,
} from "@soft/redux/payment/payment.selectors";
import { IStore } from "@soft/redux/reducers";

interface Props extends RouteComponentProps {
  paymentStatus: PAYMENT_STATUS;
  publicMessage: string | null;
  originRoute: string;
  targetRoute: string;
  fetchPaymentStatus: () => void;
  setReferenceNumber: (referenceNumber: string) => void;
  setOriginRoute: (originRoute: string, serviceLocationId: string) => void;
  setTargetRoute: (targetRoute: string) => void;
}

export const PaymentProcessedComponent = (props: Props): React.ReactElement => {
  const translate = useTranslate();

  const showNotification = (
    message: string | null,
    type: TypeOptions,
  ): void => {
    showToast(translate(message || "batsoft_pwa_generic.payment_timeout"), {
      type,
      toastId: PAYMENT_RESULT_TOAST_ID,
    });
  };

  return (
    <PaymentProcessedOrganism
      paymentStatus={props.paymentStatus}
      publicMessage={props.publicMessage}
      originRoute={props.originRoute}
      targetRoute={props.targetRoute}
      fetchPaymentStatus={props.fetchPaymentStatus}
      setReferenceNumber={props.setReferenceNumber}
      setOriginRoute={props.setOriginRoute}
      setTargetRoute={props.setTargetRoute}
      showMessageToast={showNotification}
      htmlMetaTitleText={`${translate(
        "batsoft_pwa_generic.payment_is_being_processed",
      )}`}
      htmlMetaDescriptionText={translate(
        "batsoft_pwa_generic.payment_is_being_processed",
      )}
    />
  );
};

const mapState = (store: IStore) => ({
  paymentStatus: getPaymentStatus(store),
  publicMessage: getPublicMessage(store),
  originRoute: getOriginRoute(store),
  targetRoute: getTargetRoute(store),
});

export const PaymentProcessed = compose(
  withRouter,
  connect(mapState, {
    fetchPaymentStatus,
    setReferenceNumber,
    setOriginRoute,
    setTargetRoute,
  }),
)(PaymentProcessedComponent);
